// const baseUrl =
//   (process.env.REACT_APP_API_URL || "") + "/api/users/Authenticate";
// const forgotPasswordUrl =
//   (process.env.REACT_APP_API_URL || "") + "/api/users/ForgotPassword";

export function login(user) {
  return fetch("/api/users/Authenticate", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(user),
  })
    .then(async (response) => {
      if (response.ok) return response.json();
      if (response.status === 400) {
        return undefined;
      }

      return undefined;
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}

export function forgotPassword(username) {
  //let data = { username: username };
  return fetch("/api/users/ForgotPassword", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(username),
  })
    .then(async (response) => {
      if (response.ok) return response;
      return await response.text();
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return error;
    });
}
